module.exports = __webpack_public_path__ + "static/scanme_qr_group_en-5b2160ee01d9dc3f61b5bf462866c9b6.svg";